import { ICreateSection, IGetSectionList, ISectionListSearch } from "../../../types/permissions/sectionInterface";
import { SectionActionTypes, SectionActions } from "../../actionTypes/permissions/sectionActionTypes";


export const getSectionList = (payload: ISectionListSearch): SectionActionTypes => ({
  type: SectionActions.GET_SECTION_LIST,
  payload
});

export const setSectionList = (payload: IGetSectionList[]): SectionActionTypes => ({
  type: SectionActions.SET_SECTION_LIST,
  payload
})

export const setSectionListCount = (payload: number): SectionActionTypes => ({
  type: SectionActions.SET_SECTION_PAGE_COUNT,
  payload
})

export const addSection = (payload: ICreateSection): SectionActionTypes => ({
  type: SectionActions.ADD_SECTION,
  payload
})